import { AuthContext } from 'app/providers/Authentication';
import React, { useContext } from 'react';
import { Navigate } from 'react-router';

export default function ProtectedRoute({ children }) {
  const { isAuthorized } = useContext(AuthContext);
  if (!isAuthorized) {
    return (
      <Navigate
        to="/sign-in"
        state={{
          redirect: window.location.pathname
        }}
      ></Navigate>
    );
  }

  return children;
}
